import { Finalizer, Unsubscribable } from './interfaces';

const executeFinalizer = (finalizer: Finalizer) => {
  if (typeof finalizer === 'function') {
    finalizer();
  } else {
    finalizer.unsubscribe();
  }
};

export class Subscription implements Unsubscribable {
  #finalizers = new Set<Finalizer>();
  public closed = false;

  add(finalizer: Finalizer) {
    if (this.closed) {
      executeFinalizer(finalizer);
      return;
    }
    this.#finalizers.add(finalizer);
  }

  unsubscribe() {
    if (this.closed) {
      return;
    }
    this.closed = true;
    const errors = new Set<Error>();
    for (const finalizer of this.#finalizers) {
      try {
        executeFinalizer(finalizer);
      } catch (error) {
        if (error instanceof Error) {
          errors.add(error);
        } else {
          errors.add(new Error(String(error)));
        }
      }
    }
    this.#finalizers.clear();
    if (errors.size > 0) {
      throw new AggregateError(Array.from(errors), 'Unsubscription error');
    }
  }
}
